import { useRef } from 'react'
import Styles from './ConnectButton.module.scss'
import { useButton } from '@react-aria/button'
import { LinkAngled } from 'blaze-ui/icons'

const ConnectButton = ({ onPress }: { onPress?: () => void }) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton({ onPress }, ref)

  return (
    <button {...buttonProps} ref={ref} className={Styles.root} disabled>
      <LinkAngled size={16} color="var(--light-100)" />
    </button>
  )
}

export default ConnectButton
